import Vue from 'vue'

const TOAST_DEFAULTS = {
  position: 'top-right',
  duration: 3500,
  queue: false,
}

export function notify(message, type = 'success') {
  if (!message) return
  Vue.prototype.$toast.open({
    ...TOAST_DEFAULTS,
    message,
    type,
  })
}

export function notifyError(error, fallback = 'Произошла ошибка') {
  const data = error && error.response && error.response.data
  const errors = data && data.errors

  if (errors) {
    Object.keys(errors).forEach((key) => notify(errors[key][0], 'warning'))
    return
  }

  notify(
    (data && (data.error || data.message)) ||
      (error && error.message) ||
      fallback,
    'error'
  )
}
